import { Operator } from '@jexop/core';

interface JsonOutputProps {
  space?: number;
  value?: unknown;
}

const toSerializableValue = (value: unknown, seen: WeakSet<object>): unknown => {
  if (typeof value !== 'object' || value === null) {
    return value;
  }

  if (seen.has(value)) {
    return '[Circular]';
  }

  seen.add(value);

  if (Array.isArray(value)) {
    return value.map((item) => toSerializableValue(item, seen));
  }

  return Object.fromEntries(
    Object.entries(value).map(([key, item]) => [key, toSerializableValue(item, seen)]),
  );
};

const stringifyValue = (value: unknown, space: number): string => {
  const seen = new WeakSet<object>();
  const serializableValue = toSerializableValue(value, seen);

  return JSON.stringify(serializableValue, null, space) ?? '';
};

export const jsonOutput: Operator<string> = (props: JsonOutputProps, ctx: unknown): string => {
  const space = typeof props.space === 'number' ? props.space : 2;
  const hasValue = Object.prototype.hasOwnProperty.call(props, 'value');
  const value = hasValue ? props.value : ctx;

  return stringifyValue(value, space);
};
